import { Injectable } from '@angular/core';
import { IpeTileUnitCode, type StepTile } from './../interfaces/Tile.interface';

export enum EnergyType {
    FINAL = 'FINAL',
    PRIMARY = 'PRIMARY',
    CO2 = 'CO2',
    CURRENCY = 'CURRENCY',
    CUBIC_METER = 'CUBIC_METER'
}

@Injectable({
    providedIn: 'root'
})
export class IpeStaticProvider {
    static stepTypeChoice: StepTile = {
        title: 'IPE.STEP_TYPE_CHOICE_TITLE',
        titleEdit: 'IPE.STEP_TYPE_CHOICE_TITLE_EDIT',
        percentage: 2,
        options: [
            {
                label: 'IPE.IPE_VALUE_LABEL',
                value: 'IPE_VALUE',
                image: 'assets/icons/ipe_value.png'
            },
            {
                label: 'IPE.IPE_GAUGE_LABEL',
                value: 'IPE_GAUGE',
                image: 'assets/icons/gauge.png'
            }
        ]
    };

    static stepConsumption: StepTile = {
        title: 'IPE.STEP_CONSUMPTION_TITLE',
        titleEdit: 'IPE.STEP_CONSUMPTION_TITLE_EDIT',
        percentage: 2,
        options: [
            {
                label: 'IPE.CONSTANT_1_LABEL',
                value: 'CONSTANT_1',
                unit: 'IPE.CONSTANT_1_UNIT'
            },
            {
                label: 'IPE.SURFACE_LABEL',
                value: 'SURFACE',
                unit: 'IPE.SURFACE_UNIT'
            },
            {
                label: 'IPE.OCCUPANTS_LABEL',
                value: 'OCCUPANTS',
                unit: 'IPE.OCCUPANTS_UNIT'
            },
            {
                label: 'IPE.HDD18_LABEL',
                value: 'HDD18',
                unit: 'IPE.HDD18_UNIT',
                help: 'IPE.HDD18_HELP'
            },
            {
                label: 'IPE.CDD15_LABEL',
                value: 'CDD15',
                unit: 'IPE.CDD15_UNIT',
                help: 'IPE.CDD15_HELP'
            },
            {
                label: 'IPE.CUSTOM_CONSTANT_LABEL',
                value: 'CUSTOM_CONSTANT',
                unit: 'IPE.CUSTOM_CONSTANT_UNIT'
            }
        ]
    };

    static stepEnergy: StepTile = {
        title: 'IPE.STEP_ENERGY_TITLE',
        titleEdit: 'IPE.STEP_ENERGY_TITLE_EDIT',
        percentage: 20,
        options: [
            {
                label: 'IPE.FINAL_LABEL',
                value: EnergyType.FINAL,
                unit: IpeTileUnitCode.KWH
            },
            {
                label: 'IPE.PRIMARY_LABEL',
                value: EnergyType.PRIMARY,
                unit: IpeTileUnitCode.KWH
            },
            {
                label: 'IPE.CO2_LABEL',
                value: EnergyType.CO2,
                unit: IpeTileUnitCode.KGEQCO2
            },
            {
                label: 'IPE.CURRENCY_LABEL',
                value: EnergyType.CURRENCY,
                unit: IpeTileUnitCode.EUR
            },
            {
                label: 'IPE.CUBIC_METER_LABEL',
                value: EnergyType.CUBIC_METER,
                unit: IpeTileUnitCode.M3
            }
        ]
    };

    static stepChoiceEnergy: StepTile = {
        title: 'IPE.STEP_CHOICE_ENERGY_TITLE',
        titleEdit: 'IPE.STEP_CHOICE_ENERGY_TITLE_EDIT',
        percentage: 50,
        options: []
    };

    static stepCreationRange: StepTile = {
        title: 'IPE.STEP_CREATION_RANGE_TITLE',
        titleEdit: 'IPE.STEP_CREATION_RANGE_TITLE_EDIT',
        percentage: 75,
        options: [
            {
                label: 'IPE.DEFINE_RANGES',
                value: 'DEFINE_RANGES'
            },
            {
                label: 'IPE.CUSTOM_RANGES',
                value: 'CUSTOM_RANGES'
            }
        ]
    };

    static stepFinal: StepTile = {
        percentage: 100,
        title: 'IPE.STEP_FINAL_TITLE',
        titleEdit: 'IPE.STEP_FINAL_TITLE_EDIT',
        options: []
    };

    static unitTab = {
        [IpeTileUnitCode.KWH]: 'kWh',
        [IpeTileUnitCode.KGEQCO2]: 'kg',
        [IpeTileUnitCode.EUR]: '€',
        [IpeTileUnitCode.M3]: 'm³'
    };

    static stepsCreation: StepTile[] = [
        IpeStaticProvider.stepTypeChoice,
        IpeStaticProvider.stepConsumption,
        IpeStaticProvider.stepEnergy,
        IpeStaticProvider.stepChoiceEnergy,
        IpeStaticProvider.stepCreationRange,
        IpeStaticProvider.stepFinal
    ];
}
